import { styled, TextField } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";

export const StandardTextField = styled(TextField)(() => {
    return {
        height: '3.5rem',
        width: '100%',
        display: 'flex',

        backgroundColor: '#FFF',

        '& .MuiFormLabel-asterisk': {
            color: "red"
        },
    }
});

export const StandardDateField = styled(DatePicker)(() => {
    return {
        height: '3.5rem',
        width: '100%',
        display: 'flex',

        backgroundColor: '#FFF',

        '& .MuiFormLabel-asterisk': {
            color: "red"
        },
    }
});
